import { EncodingCounters } from 'core/api'

export * from 'core/shared/utils'

export const showCountersOnEncoding = (initialType: string, counters: EncodingCounters) => {
  if (counters?.row) {
    return counters.row.expected + counters.row.extra > 0
  }
  return counters?.order?.expected + counters?.order?.extra > 0
}

export const encodingStartAntennaAfterSimpleItemIdentifier = () => true

export const DEFAULT_PRODUCT_ATTRIBUTES = 5
